import { render, staticRenderFns } from "./PlanosLista.vue?vue&type=template&id=067da9a0&scoped=true"
import script from "./PlanosLista.vue?vue&type=script&lang=js"
export * from "./PlanosLista.vue?vue&type=script&lang=js"
import style0 from "./PlanosLista.vue?vue&type=style&index=0&id=067da9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067da9a0",
  null
  
)

export default component.exports